"use client";

import { FC } from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import Button from "@mui/material/Button";

import { useStyles } from "./styles";
import { useSessionStorage } from "@/hooks/useStorage";

interface FacebookButtonProps {
  actionType: "login" | "register";
  subscribeToEmails?: boolean;
  disabled?: boolean;
  className?: string;
  onSuccess?: () => void | Promise<void>;
}

const FacebookButton: FC<FacebookButtonProps> = ({
  actionType,
  disabled = false,
  subscribeToEmails = true,
  className,
  onSuccess,
}) => {
  const { classes, cx } = useStyles({ disabled });
  const [googleAds] = useSessionStorage("GoogleAds", false);

  const emailSubscriptionQuery =
    actionType === "register" && subscribeToEmails ? "?subscribe=true" : "";

  const gtag_report_conversion = () => {
    (window as any).gtag("event", "conversion", {
      send_to: "AW-11397301260/_bvGCOu5rtsZEIyI1Loq",
      value: 0.1,
      currency: "AUD",
    });
  };

  const handleSubmit = async () => {
    if (googleAds && actionType === "register") {
      gtag_report_conversion();
    }

    // Use localStorage instead of sessionStorage (survives navigation)
    if (onSuccess) {
      localStorage.setItem("oauthSuccessCallback", "facebook");
      localStorage.setItem("oauthInitiatedAt", Date.now().toString());
    }
  };

  return (
    <a
      href={`${process.env.NEXT_PUBLIC_API_URL}/auth/facebook${emailSubscriptionQuery}`}
      className={classes.link}
    >
      <Button
        variant="contained"
        className={cx(classes.facebookButton, className)}
        disabled={disabled}
        onClick={handleSubmit}
      >
        <FacebookIcon className={classes.facebookIcon} />
        Sign {actionType === "login" ? "in" : "up"} with Facebook
      </Button>
    </a>
  );
};

export default FacebookButton;
